import React from "react";
import AppWrapper from "./components/AppWrapper";

function App() {
  return <AppWrapper />;
}

export default App;
